"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ExternalMenuLink(_ref) {
  var href = _ref.href,
      key = _ref.key,
      name = _ref.name,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    className: className,
    key: key,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: onClick
  }, name));
}

var _default = ExternalMenuLink;
exports["default"] = _default;